import { useEffect } from 'react'

import { EMPTY_LIST } from '../../../../constants/common'
import { useInlineNotifications } from '../../../../hooks'
import {
  DocFlowSendingWidgetNotificationType,
  isDocFlowSendingWidgetStatusCompleted,
  isDocFlowSendingWidgetStatusStartedWithError,
} from '../../DocFlowSending'
import { useDocFlowSendingContext } from '../useDocFlowSendingContext'

export function useDocFlowSendingWidgetNotifications({
  getInitialNotifications,
  phase,
  widgetNotifications,
}) {
  const { processData } = useDocFlowSendingContext()

  const initialNotifications = getInitialNotifications?.() || EMPTY_LIST

  const {
    handleAddNotification,
    handlePrependNotification,
    handleRemoveNotification,
    notifications,
  } = useInlineNotifications({
    initialNotifications,
  })

  const isSuccess = isDocFlowSendingWidgetStatusCompleted(processData?.[phase])

  const isError = isDocFlowSendingWidgetStatusStartedWithError(
    processData?.[phase]
  )

  useEffect(() => {
    if (isSuccess) {
      handlePrependNotification(
        widgetNotifications[DocFlowSendingWidgetNotificationType.Success]
      )
    } else {
      handleRemoveNotification(
        widgetNotifications[DocFlowSendingWidgetNotificationType.Success].id
      )
    }
  }, [isSuccess, widgetNotifications])

  useEffect(() => {
    if (isError) {
      handlePrependNotification(
        widgetNotifications[DocFlowSendingWidgetNotificationType.Error]
      )
    } else {
      handleRemoveNotification(
        widgetNotifications[DocFlowSendingWidgetNotificationType.Error].id
      )
    }
  }, [isError, widgetNotifications])

  return {
    handleAddNotification,
    handlePrependNotification,
    handleRemoveNotification,
    notifications,
  }
}
